import Analytics from './components/Analytics';
import Auth from './components/Auth';
import PersonalPlan from './components/PersonalPlan';
import Subscriptions from './components/Subscriptions';
import UserApi from './components/User';

function ApiInstance() {
    const user = new UserApi();
    const subscriptions = new Subscriptions();
    const personalPlan = new PersonalPlan();
    const auth = new Auth();
    const analytics = new Analytics();

    return {
        user,
        subscriptions,
        personalPlan,
        auth,
        analytics,
    };
}

export default ApiInstance();
